import { LocalDate } from '@js-joda/core'
import { HearingSectionModel } from '../../../../store/annotations/annotations.model'
import { RealTimeSttTranscriptElementBase } from '../../../../types/real-time-stt-transcript-element-base'

export interface RealTimeSttHearingHeader extends RealTimeSttTranscriptElementBase {
  type: 'HearingHeader'

  hearingAnnotation: HearingSectionModel
}

export function toHearingHeader(annotation: HearingSectionModel, date: LocalDate): RealTimeSttHearingHeader {
  return {
    type: 'HearingHeader' as const,
    id: annotation.id,
    startTime: annotation.startTime.atDate(date),
    // End time is optional, but also unused for our purposes, easiest to always just have it be the same as start time
    endTime: annotation.startTime.atDate(date),
    hearingAnnotation: annotation,
  }
}
